import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { ContactListItem } from "client/Api/Email/contacts";
import { ContactItem, ContactItemIdentifier } from "../ContactItem/ContactItem";
import styles from "./Group.module.less";
import { AddressBookOverviewLayoutKind } from "../../OverviewLayoutKindSelector";
import { AddressBookContactSource } from "../../Overview";

export type GroupProps = {
	layoutKind: AddressBookOverviewLayoutKind;
	title: string;
	emptyTitle: string;
	source: AddressBookContactSource;
	items: readonly ContactListItem[];
	activeItemId: ContactItemIdentifier | null;
	onOpenItem(id: ContactItemIdentifier): void;
	isResponsive: boolean;
};

export const Group = (props: GroupProps): ReactElement => {
	const {
		title,
		emptyTitle,
		source,
		items,
		activeItemId,
		layoutKind,
		onOpenItem,
		isResponsive
	} = props;

	return (
		<>
			<h3 className={styles.title}>{title === "" ? emptyTitle : title}</h3>
			<ul
				{...setTrackingId("list")}
				className={layoutToClassMap[layoutKind]}
			>
				{items.map(item => (
					<li
						className={styles.item}
						key={item.id}
					>
						<ContactItem
							contact={item}
							isActive={activeItemId?.id === item.id && activeItemId.source === source}
							onNavigate={() => onOpenItem({ id: item.id, source})}
							layoutKind={layoutKind}
							isResponsive={isResponsive}
							source={source}
						/>
					</li>
				))}
			</ul>
		</>
	);
};
Group.displayName = "Group";

const layoutToClassMap: Record<AddressBookOverviewLayoutKind, string> = {
	[AddressBookOverviewLayoutKind.Grid]: styles.items_grid,
	[AddressBookOverviewLayoutKind.List]: styles.items_list
};